'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Decorators


// Utils


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _androidOnly = require('./androidOnly');

var _androidOnly2 = _interopRequireDefault(_androidOnly);

var _androidKeyboardStateDecorator = require('./androidKeyboardStateDecorator');

var _androidKeyboardStateDecorator2 = _interopRequireDefault(_androidKeyboardStateDecorator);

var _propsComparisons = require('../../../utils/react/propsComparisons');

var _selectionActions = require('../../../element/selection/selectionActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var keyboardNoLongerVisible = (0, _propsComparisons.noLonger)('keyboardVisible');

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchStopEditing: function dispatchStopEditing() {
            return dispatch((0, _selectionActions.finishEditingElement)());
        }
    };
};

var AndroidStopEditingHelper = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), (0, _androidOnly2.default)(_class = _dec(_class = (0, _androidKeyboardStateDecorator2.default)(_class = function (_React$Component) {
    _inherits(AndroidStopEditingHelper, _React$Component);

    function AndroidStopEditingHelper() {
        _classCallCheck(this, AndroidStopEditingHelper);

        return _possibleConstructorReturn(this, (AndroidStopEditingHelper.__proto__ || Object.getPrototypeOf(AndroidStopEditingHelper)).apply(this, arguments));
    }

    _createClass(AndroidStopEditingHelper, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var dispatchStopEditing = this.props.dispatchStopEditing;


            if (keyboardNoLongerVisible(this.props, nextProps)) dispatchStopEditing();
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return AndroidStopEditingHelper;
}(_react2.default.Component)) || _class) || _class) || _class);


AndroidStopEditingHelper.propTypes = {
    dispatchStopEditing: _propTypes2.default.func,
    keyboardVisible: _propTypes2.default.bool
};

exports.default = AndroidStopEditingHelper;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/android/AndroidStopEditingHelper.js
// module id = 2208
// module chunks = 0